module.exports = __webpack_public_path__ + "media/src/components/Navigation/NotificationHeader/img/flags/eur-0420e634b15c416fbdc13765fa79dc19.svg";